import { useMutation } from '@tanstack/react-query';

import * as services from '../../services';

export const useGenerateRecognitionsDetailReport = options => {
  return useMutation(async ({ params, body }) => {
    await services.generateRecognitionReport(params, body);
  }, options);
};
